import React from 'react';
import { Editor } from '@tinymce/tinymce-react';
import {Tab} from 'semantic-ui-react';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { a11yDark } from 'react-syntax-highlighter/dist/esm/styles/hljs';
// https://highlightjs.org/static/demo/
function EditorComponent(props){
  return (
  <Editor
        apiKey='fjpnqx8efvljzicrvreotudyb6308itw8vjw2pidhp0jxzwk'
        id='circuit_text'
        value={props.description}
        init={{
        theme_url: 'https://cdn.tiny.cloud/1/invalid-origin/tinymce/5.7.1-108/themes/silver/theme.min.js',
        branding: false,
        theme_url: 'https://cdn.tiny.cloud/1/fjpnqx8efvljzicrvreotudyb6308itw8vjw2pidhp0jxzwk/tinymce/5.7.1-108/themes/silver/theme.min.js',
        height: '100%',
        menubar: false,
        plugins: [
          'advlist autolink lists link image',
          'media paste'
        ],
        toolbar:
          'forecolor backcolor | bold italic | alignleft aligncenter alignright alignjustify | \
          bullist numlist outdent indent | removeformat | image link | formatselect'
      }}
      onEditorChange={(content, editor) => {
        props.setDescription(content);
          setTimeout(()=> {
              window.thumbs.sync(true);
          }, 2)
      }}
      />
  )
}
function SideTabs(props)
{
    React.useEffect(() => {
        window.sideTabs = this;
    }, [])

  let panes = [
    {
      menuItem: props.isEditingAssignment ? l.question : l.notes,
      render: () => <Tab.Pane attached={false}>
        <EditorComponent description={props.description} setDescription={props.setDescription} />
      </Tab.Pane>,
    }
  ]

    if (!props.isEditingAssignment){
        panes.push({
            menuItem: 'NGSPice',

                render: () => <Tab.Pane style={{backgroundColor: '#2b2b2b' }} attached={false}>
            <SyntaxHighlighter wrapLongLines={false} showLineNumbers={false} language="armasm" style={a11yDark}>
                {props.NGSpiceNetList}
            </SyntaxHighlighter>
        </Tab.Pane>,
        });
    }

    return (props.useNGSpice || props.isEditingAssignment) ? (
        <Tab style={{width: '100%', height: '100%'}} defaultActiveIndex={props.ngSpiceSelected ? 1 : 0} menu={{ secondary: true, pointing: true }} panes={panes} />
    ) : (
      <EditorComponent description={props.description} setDescription={props.setDescription} />
    )
}

export default SideTabs;

